(function () {
    "use strict";

    angular
        .module("app")
        .component("header", { // header
            templateUrl: "src/app/_shared/header/header.html",
            controller: controller
        });

    /**
     * @param {ng.IScopeService} $scope
     * @param {ng.IHttpService} $http
     * @param {ng.ILocationService} $location
     * @param {PimsSc.SessionService} session
     */
    function controller($scope, $http, $location, session, loginModal) {
        const $ctrl = this;
        $ctrl.loginUrl = "/login?redirectTo=" + encodeURI($location.path());
        $ctrl.session = session;
        $ctrl.customer = session.customer;
        $ctrl.searchText = "";
        $ctrl.showLogo = false;

        $scope.$watch(() => session.customer, customer => {
            if (!customer) {
                $ctrl.showLogo = false;
                $ctrl.logoSrc = "/dist/images/logo.png";
            } else {
                $ctrl.customer = session.customer;
                $http.get(`/api/images/customer/${customer.customer_id}/small?default=false`,
                        { responseType: 'arraybuffer' })
                    .then(result => {
                        $ctrl.showLogo = true;
                        const blob = new Blob([result.data], { type: "imageType" });
                        $ctrl.logoSrc = window.URL.createObjectURL(blob);
                    })
                    .catch(() => {
                        $ctrl.showLogo = false;
                        $ctrl.logoSrc = "/dist/images/logo.png";
                    });
            }
        });

        $scope.$watch(() => session.products.searchCriteria.searchText, newSearchText => {
            if (!newSearchText || newSearchText.length == 0) {
                $ctrl.searchText = "";
            }
        });

        $ctrl.$onInit = () => {
            //session.refresh(true);
        };

        $ctrl.login = () => {
            loginModal();
        };

        $ctrl.logOut = () => {
            session.logOut().then(() => {
                $location.path("/");
            });
        };

        $ctrl.logoClicked = () => {
            $location.path("/");
        };

        $ctrl.search = () => {
            session.products.searchCriteria.searchText = $ctrl.searchText;
            session.gotoProductSearch();
        }

        $ctrl.customerSelected = (customer) => {
            session
                .setCustomer(customer)
                .then(() => {
                    $ctrl.search();
                });
        };
    }
    controller.$inject = ["$scope", "$http", "$location", "sessionService", "loginModal"];

})()